export const putterData = [
  {
    id: "G1",
    img: "images/fitting/G1.Webp",
    title: "GEORGE 1 PUTTER (G1)",
    link: "G1",
    price: "Limited Edition",
    src: "images/gtdProduct/G1",
  },
];
